<template>
  <div class="w-col w-col-6 recent-portfolio-col-right">
    <div class="w-dyn-list">
      <div class="w-dyn-items w-row w-clearfix recent-work-list">
        <ProjectListItem
          v-for="project in projects"
          :key="project.id"
          :project="project"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ProjectListItem from '@/components/ProjectListItem'

export default {
  components: {
    ProjectListItem,
  },

  props: {
    projects: {
      required: true,
      type: Array,
    },
  },
}
</script>
